import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CentroCostoNivel2 } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CentroCostoNivel2FormGroup = ({ iError, iTouched, iValue, setFieldValue, idNodoPadre, updateStore, rowIndex }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('_idCentroCostoNivel2', salida.value)
      setFieldValue('centroCostoNivel2Info', salida.label)

      setTimeout(() => {
        updateStore()
        KeyEventUtil.leaveOnKeyEvent(`input-det-importeDebe-${rowIndex}`)
      }, 200)
    },
    [setFieldValue, rowIndex, updateStore]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('_idCentroCostoNivel2', '')
    setFieldValue('centroCostoNivel2Info', '')

    setTimeout(() => {
      updateStore()
      KeyEventUtil.leaveOnKeyEvent(`select-det-centroCostoNivel2-${rowIndex}`)
    }, 200)
  }, [setFieldValue, rowIndex, updateStore])

  return (
    <Form.Group>
      <Col md={12}>
        {iValue ? (
          <ClearInputGroup id='centroCostoNivel2' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CentroCostoNivel2 id={`select-det-centroCostoNivel2-${rowIndex}`} idNodoPadre={idNodoPadre} onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel2FormGroup)
